/**
 * Reads an SSE stream from a fetch Response, parsing each event and
 * dispatching to callbacks. Handles text decoding, line buffering,
 * and JSON parsing — callers handle business logic via onChunk/onDone.
 *
 * @param {Response} response - fetch Response with readable body
 * @param {{ onChunk: (delta: string) => void, onDone: (data: object) => void }} callbacks
 */
export async function readSSEStream(response, { onChunk, onDone }) {
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split('\n');
    buffer = lines.pop() || '';

    for (const line of lines) {
      if (line.startsWith('data: ')) {
        const jsonStr = line.slice(6);
        if (jsonStr === '[DONE]') continue;

        try {
          const data = JSON.parse(jsonStr);

          if (data.chunk) {
            onChunk(data.chunk);
          }

          if (data.done) {
            onDone(data);
          }
        } catch (e) {
          console.error('[readSSEStream] SSE parse error:', e);
        }
      }
    }
  }
}
